module.exports = __webpack_public_path__ + "img/device.0a7d1205.png";